import { inject } from "@angular/core";

import { HeadService } from "@hermes/utils-generic-services-head";

/**
 * Return a `ResolveFn<string>` resolving route title, dedicated to use in Angular route's `title` property
 *
 * For more complex scenario, see {@link HeadService.getTitle}.
 *
 * @example
 * const routes = [
 *     {
 *         path: "example",
 *         loadComponent: () => import("..."),
 *         title: hermesRouteTitle($localize`my-key`),
 *     }
 * ];
 *
 * @param title
 * @param withSuffix
 */
export function hermesRouteTitle(
    title: string,
    withSuffix = true,
): () => Promise<string> {
    return () => inject(HeadService).getTitle(title, withSuffix);
}
